import React, { useEffect, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { toast } from 'react-toastify';

// Small icon button that copies `value` to the clipboard and briefly shows a tick.
function CopyButton({ value, label = 'value', text }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(timer);
  }, [copied]);

  if (value === null || value === undefined || value === '') return null;

  const handleCopy = async (event) => {
    event.stopPropagation();
    try {
      await navigator.clipboard.writeText(String(value));
      setCopied(true);
      toast.success(`${label} copied`, { toastId: `copy:${label}`, autoClose: 1500 });
    } catch (_) {
      toast.error(`Couldn't copy ${label.toLowerCase()}. Please copy it manually.`);
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      title={copied ? 'Copied' : `Copy ${label.toLowerCase()}`}
      aria-label={`Copy ${label.toLowerCase()}`}
      className={`inline-flex flex-none items-center justify-center gap-1.5 rounded-md transition-colors ${text ? 'h-8 border border-slate-200 bg-white px-2.5 text-xs font-semibold' : 'h-6 w-6'} ${
        copied ? 'bg-green-50 text-green-600' : text ? 'text-[#0a1445] hover:border-[#fb6635] hover:text-[#fb6635]' : 'text-slate-400 hover:bg-orange-50 hover:text-[#fb6635]'
      }`}
    >
      {copied ? <Check className="h-3.5 w-3.5" strokeWidth={2.5} /> : <Copy className="h-3.5 w-3.5" strokeWidth={2} />}
      {text && <span>{copied ? 'Copied' : text}</span>}
    </button>
  );
}

export default CopyButton;
